<template>
    <v-container>
        <module-bar :title="title" icon="mdi-text-box-check-outline" />

        <v-card outlined>
            <v-card-text>
                <v-form v-model="valid" ref="formRent">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field label="Nombre" v-model="name" :rules="rulesName" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select label="Provincia" :items="locations" :rules="rulesLocation" v-model="locationId"
                                item-value="id" item-text="name" :loading="loadingLocation" />
                        </v-col>

                        <v-col>
                            <v-text-field label="Distrito o localidad" v-model="district" :rules="rulesDistrict" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select label="Semana" :items="weeks" :rules="rulesWeek" v-model="week" item-value="value"
                                item-text="name" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea outlined label="Direccion" v-model="address" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-file-input label="Foto #1" v-model="photo1" show-size
                                accept="image/png, image/jpeg, image/bmp" :rules="rulesPhoto" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field label="Monto" type="number" v-model="amount" :rules="rulesAmount" />
                        </v-col>

                        <v-col cols="12" md="6" v-if="rent">
                            <v-img style="cursor: pointer" v-if="rent.photo_1" width="200" :src="rent.photo_1"
                                :lazy-src="rent.photo_1_thumb" aspect-ratio="1" contain class="grey lighten-2"
                                @click="openDialogPhoto(rent.photo_1, 1)">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-col>

                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="schema == 'edit'" text color="red" @click="deleteRent" :loading="loadingDeleteRent">
                    eliminar
                    alquiler</v-btn>
                <v-spacer />
                <v-btn text color="red" v-if="schema == 'edit'" @click="closeDialogRent(null)">cancelar</v-btn>
                <v-btn :loading="loadingProcess" @click="processRent" text color="primary">{{ schema == "new" ?
                    "GUARDAR" :
                    "EDITAR"
                }}</v-btn>
            </v-card-actions>
        </v-card>

        <!-- dialogo foto -->
        <v-dialog v-if="rent" v-model="dialogPhoto" width="800">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-img :src="photoSelected" />
                </v-card-text>

                <v-card-actions>
                    <v-btn text color="red" @click="deletePhoto" :loading="loadingDeletePhoto">eliminar foto</v-btn>
                    <v-spacer />
                    <v-btn text @click="closeDialogPhoto">cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from "../General/ModuleBar.vue";

export default {
    components: { ModuleBar },
    props: ["schema", "title", "rent", "click"],

    mounted() {
        this.loadLocations();

        this.loadLocations();
        if (this.rent) {
            this.loadRent();
        }
    },

    data() {
        return {
            district: "",
            loadingDelete: false,
            locationId: 0,
            loadingLocation: false,
            locations: [],
            dialogPhoto: false,
            loadingDeletePhoto: false,
            valid: false,
            loadingProcess: false,
            name: "",
            photo1: null,
            photoSelected: "",
            photoNumber: 0,
            loadingDeleteRent: false,
            address: "",
            amount: 0,
            week: 0,
            weeks: [
                { value: 1, name: "Semana 1 (Dia 1 al 7)" },
                { value: 2, name: "Semana 2 (Dia 8 al 14)" },
                { value: 3, name: "Semana 3 (Dia 15 al 22)" },
                { value: 4, name: "Semana 4 (Dia 23 al 31)" },
            ],

            rulesType: [(value) => (value && value > 0) || "Seleccione el tipo"],
            rulesName: [
                (value) => (value && value.length > 0) || "Ingrese el nombre",
            ],

            rulesLocation: [
                (value) => (value && value > 0) || "Seleccione la ubicacion",
            ],

            rulesAmount: [
                (value) => (value && value.toString().length > 0 || "Ingrese el monto")
            ],

            rulesDistrict: [
                (value) => (value && value.length > 0) || "Ingrese el distrito o localidad",
            ],

            rulesPhoto: [
                (value) =>
                    !value ||
                    value.size < 4000000 ||
                    "La foto no puede pesar mas de  4 Mb!",
            ],

            rulesWeek: [
                (value) => (value && value > 0) || "Seleccione la semana",
            ],
        };
    },

    watch: {
        click() {
            this.loadRent();
        },

        name(value) {
            this.name = value.toUpperCase();
        },
    },

    methods: {
        processRent() {
            if (this.valid) {
                this.loadingProcess = true;
                setTimeout(() => {
                    let payload = new FormData();

                    payload.append("name", this.name);
                    payload.append("address", this.address);
                    payload.append("photo1", this.photo1);
                    payload.append("amount", this.amount);
                    payload.append("location_id", this.locationId);
                    payload.append("week", this.week);
                    payload.append("district", this.district);

                    if (this.schema == "edit") payload.append("rent_id", this.rent.id);

                    let path =
                        this.schema == "new" ? "storeRentAction" : "updateRentAction";

                    this.$store
                        .dispatch(path, payload)
                        .then((res) => {
                            this.loadingProcess = false;
                            if (this.schema == "edit") this.closeDialogRent(res);
                            this.clear();
                        })
                        .catch(() => {
                            this.loadingProcess = false;
                        });
                }, 500);
            } else {
                this.$refs.formRent.validate();
            }
        },

        clear() {
            this.name = "";
            this.address = "";
            this.amount = 0;
            this.photo1 = null;
            this.locationId = 0;
            this.district = "";
            this.$refs.formRent.resetValidation();
        },

        closeDialogRent(data) {
            this.$emit("closeDialogRent", data);
        },

        loadRent() {
            if (this.rent) {
                this.name = this.rent.name;
                this.address = this.rent.address;
                this.locationId = parseInt(this.rent.location_id);
                this.amount = this.rent.amount;
                this.week = parseInt(this.rent.week);
                this.district = this.rent.district || "";
            }
        },

        openDialogPhoto(photo, number) {
            this.dialogPhoto = true;
            this.photoSelected = photo;
            this.photoNumber = number;
        },

        closeDialogPhoto() {
            this.dialogPhoto = false;
            this.photoSelected = "";
        },

        deletePhoto() {
            this.$confirm({
                message: `Quieres eliminar esta foto?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDeletePhoto = true;
                        setTimeout(() => {
                            let payload = {
                                photo_number: 1,
                                rent_id: this.rent.id,
                            };

                            this.$store
                                .dispatch("deletePhotoRentAction", payload)
                                .then(() => {
                                    this.loadingDeletePhoto = false;
                                    this.dialogPhoto = false;
                                    this.photoFinish();
                                })
                                .catch(() => {
                                    this.loadingDeletePhoto = false;
                                });
                        }, 500);
                    }
                },
            });
        },

        photoFinish() {
            if (this.photoNumber == 1) {
                this.rent.photo_1 = null;
                this.rent.photo_1_short = null;
                this.rent.photo_1_thumb = null;
                this.rent.photo_1_thumb_short = null;
            }
        },

        deleteRent() {
            this.$confirm({
                message: `Quieres eliminar este alquiler, no podras revertir o recuperar la informacion?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDeleteRent = true;
                        setTimeout(() => {
                            this.$store
                                .dispatch("deleteRentAction", this.rent.id)
                                .then(() => {
                                    this.loadingDeleteRent = false;
                                    this.rent.is_delete = true;
                                    this.closeDialogRent(this.rent);
                                })
                                .catch(() => {
                                    this.loadingDeleteRent = false;
                                });
                        }, 500);
                    }
                },
            });
        },

        loadLocations() {
            this.loadingLocation = true;
            setTimeout(() => {
                this.$store.dispatch("findLocations").then((res) => {
                    this.locations = res;
                    this.loadingLocation = false;
                });
            }, 500);
        },
    },
};
</script>

<style></style>